import { LazyLoad } from '@petconsole/pure-fe-mui';

const BusinessAdmin = LazyLoad(() => import('./BusinessAdmin'));

export { BusinessAdmin };
